<nb-card>
  <nb-card-header>
    <div class="summary">
      <div class="item" (click)="receive(notification)">
        <div class="avatar">
          <ngx-view-user-display
            [user]="notification.fromAuthor"
            [mode]="'avatar'"
          ></ngx-view-user-display>

          <nb-icon
            class="iconType"
            [icon]="notification.iconType"
            [pack]="notification.iconType == 'liked' ? 'liked-icon' : ''"
            [status]="
              notification.iconType == 'alert-triangle-outline'
                ? 'warning'
                : notification.iconType == 'liked'
                ? 'info'
                : 'success'
            "
          ></nb-icon>
        </div>

        <div>
          <ngx-view-user-display
            [user]="notification.fromAuthor"
            [mode]="'name'"
          ></ngx-view-user-display>
          <ngx-view-time-ago
            [currentDate]="notification.createdOn"
          ></ngx-view-time-ago>

          <div *ngIf="notification.type != 'Bình luận'" class="content">
            <span class="description">
              {{ notification.type }} {{ notification.preTitle }}
            </span>

            <nb-icon [icon]="notification.iconMode"></nb-icon>
            <span class="text-hint description">
              "{{ notification.fromTitle }}"
            </span>

            <span *ngIf="notification.fromDescription != ''">
              trong
              <a class="text-link link" (click)="navigateRef(notification)">
                {{
                  notification.fromDescription.length < 200
                    ? notification.fromDescription
                    : notification.fromDescription.substring(0, 200) + "..."
                }}
              </a>
            </span>
          </div>

          <div *ngIf="notification.type == 'Bình luận'" class="content">
            <span class="description"
              >{{ notification.type }} {{ notification.preTitle }}
            </span>
            <nb-icon [icon]="notification.iconMode"></nb-icon>
            <span class="text-link">
              <a class="link" (click)="navigateRef(notification)">
                {{ notification.fromTitle }}
              </a>
              :
            </span>
            <span *ngIf="notification.fromDescription != ''" class="text-hint">
              {{
                notification.fromDescription.length < 60
                  ? notification.fromDescription
                  : notification.fromDescription.substring(0, 60) + "..."
              }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="button-action">
      <!-- <button
        nbButton
        ghost
        status="danger"
        size="small"
        [disabled]="submitted"
        [class.btn-pulse]="submitted"
        (click)="delete(notification)"
      >
        <nb-icon icon="trash-2-outline"></nb-icon>
      </button> -->

      <button
        *ngIf="!notification.isReceived"
        nbButton
        ghost
        status="info"
        size="small"
        [disabled]="submitted"
        [class.btn-pulse]="submitted"
        (click)="receive(notification)"
      >
        <nb-icon icon="radio-button-on"></nb-icon>
      </button>
    </div>
  </nb-card-header>

  <!-- <nb-card-body>
    <div class="text-heading">{{ notification.fromTitle }}</div>
    <div class="text-hint">{{ notification.fromDescription }}</div>
  </nb-card-body> -->

  <nb-card-footer>
    <!-- <div class="button-actions"></div> -->
  </nb-card-footer>
</nb-card>
